import HistoryList from '../components/history/HistoryList'
import HistorySummary from '../components/history/HistorySummary'
import { useI18n } from '../i18n'
import { viewPanelState } from '../state/appUiStore'

/**
 * Renders the history tab (summary, time blocks, and fast list).
 *
 * @returns The history view element.
 */
const HistoryView = () => {
   useI18n()

   return (
      <div
         id="history-view"
         class="view-panel w-full lg:col-span-2"
         data-view-state={viewPanelState('history')}
      >
         <HistorySummary />
         <HistoryList />
      </div>
   )
}

export default HistoryView
